import type { FeedItems } from "../../../types/content/feedItem";

import { isFeedItem } from "../../../utils/typechecks";

const omitRepeated = (
  prevGroup: FeedItems,
  nextGroupToAdd: FeedItems,
  initialItems: FeedItems,
  onlyNewGroups?: boolean,
): FeedItems => {
  const existingIds = new Set<string>();

  [...initialItems, ...prevGroup].forEach((item) => {
    if (isFeedItem(item) && item.id) {
      existingIds.add(item.id);
    }
  });

  const filteredArticles = nextGroupToAdd.filter((item) => {
    if (!isFeedItem(item)) {
      return true;
    }

    if (!item.id) {
      return true;
    }

    return !existingIds.has(item.id);
  });

  return onlyNewGroups
    ? [...filteredArticles]
    : [...prevGroup, ...filteredArticles];
};

export { omitRepeated };
